import { atom } from 'jotai'
import { ChallengeService } from '@duck/api-definitions'

// --- Solution handlers (for tab-based Solution component; set by Workspace) ---
export const workspaceSolutionHandlersAtom = atom<{
  handleSolutionChange: (solution: string) => void
  handleChartAdded: (solution: string, chart: ChallengeService.Chart) => void
  handleChartRemoved: (solution: string, remainingChartIds: string[]) => void
} | null>(null)

// --- Workspace loaded data (for new components; WorkspaceParent still passes props for backward compat) ---
export const workspaceChallengeIdAtom = atom<string | null>(null)
export const workspaceChallengeAtom = atom<ChallengeService.ChallengeInfo['challenge'] | null>(null)
export const workspaceTaskAtom = atom<ChallengeService.ChallengeInfo['task'] | null>(null)
export const workspaceChartsAtom = atom<ChallengeService.WorkState['charts'] | null>(null)
export const workspaceErrorAtom = atom<ChallengeService.ChallengeErrorCode | null>(null)
export const workspaceIsVisibleAtom = atom<boolean>(false)
export const workspaceDisclaimerDialogOpenAtom = atom<boolean>(false)

// --- WorkspaceTabs view count (tracks if there are two views) ---
export const workspaceTabsHasTwoViewsAtom = atom<boolean>(false)

// --- Solution review (pre-submit) visibility ---
export const workspaceSolutionReviewVisibleAtom = atom<boolean>(false)

// --- Recent tips from user progress ---
export const workspaceRecentTipsAtom = atom<ChallengeService.RecentTipsEntry[]>([])

// --- Table metadata (row/size counts per table, fetched once per workspace load) ---
export const workspaceTableMetadataAtom = atom<Record<string, ChallengeService.TableMetadataEntry> | null>(null)

// --- Workspace Settings dialog open state ---
export const workspaceSettingsOpenAtom = atom<boolean>(false)

// --- Pending weapon pick (drives the PickWeaponDialog before boot) ---
export type PendingWeaponPick = {
  taskId: string
  allowedWeapons: ChallengeService.TaskWeaponsOfChoiceEnum[]
  onPicked: (weapon: ChallengeService.TaskWeaponsOfChoiceEnum) => void
  onCancelled: () => void
}
export const pendingWeaponPickAtom = atom<PendingWeaponPick | null>(null)

